import { Box, Button, Container, Grid, MobileStepper, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { formatarValorMonetario } from "../../../../helpers/masks";
import { useState } from "react";
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { IResultRegRecebimento } from "../../../../types/mutations/financeiro/registrar-recebimento-titulos";
import ShareIcon from '@mui/icons-material/Share';
import moment from "moment";
import BtnImprimirRecibo from "./BtnImprimirRecibo";
import BtnCompartilhar from "../../../../components/BtnCompartilhar";

export default function MostrarRecibo({
    tipoModal,
    temRecibo = true
}: MostrarReciboProps) {

    const { watch } = useFormContext();

    const recebimentoRegistrado: IResultRegRecebimento = tipoModal === 'Pagar' ? watch('pagamentoRegistrado') : watch('recebimentoRegistrado')
    const maxSteps = recebimentoRegistrado.recibos.length
    const numRecibo = recebimentoRegistrado.recibos[0].recibo

    const [activeStep, setActiveStep] = useState(0);

    //funções manipuladoras
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    //

    return (
        <Container maxWidth="sm">
            <Grid container spacing={2} my={3} sx={{ minHeight: 300 }}>
                <Grid container size={{xs: 12}}>
                    <Grid size={{xs: 3}}>
                        <img src="/imgs/img-comprovante.png" alt="img" width={91} />
                    </Grid>

                    <Grid size={{xs: 9}}>
                        <Box display="flex" flexDirection="column" justifyContent="flex-end">
                            <Typography variant="h4">{tipoModal === 'Pagar' ? 'Pagamento' : 'Recebimento'} registrado</Typography>
                            <Typography variant="subtitle1">{moment(recebimentoRegistrado.data_hora).format('DD/MM/YYYY HH:mm')}</Typography>
                        </Box>
                    </Grid>
                </Grid>

                {
                    recebimentoRegistrado.recibos.map((item, index: number) => {
                        if (index !== activeStep) return (<></>)

                        return (
                            <Grid key={index} container size={{xs: 12}} spacing={2} columnSpacing={20}>
                                <Grid size={{xs: 12, md: 5}}>
                                    <LabelRecibo
                                        titulo={tipoModal === 'Pagar' ? "Valor pago" : "Valor recebido"}
                                        valor={item.valor ? formatarValorMonetario(item.valor) : "-"}
                                    />
                                </Grid>
                            {
                                temRecibo &&
                                <Grid size={{xs: 12, md: 7}}>
                                    <LabelRecibo
                                        titulo="Forma"
                                        valor={item.forma_recebimento}
                                    />
                                </Grid>
                            }

                                <Grid size={{xs: 12, md: temRecibo ? 5 : 7}}>
                                    <LabelRecibo
                                        titulo={tipoModal === 'Pagar' ? "Pago por" : "Recebido por"}
                                        valor={recebimentoRegistrado.recebido_por}
                                    />
                                </Grid>
                                {
                                    temRecibo &&
                                    <Grid size={{xs: 12, md: 7}}>
                                        <LabelRecibo
                                            titulo="Comprovante"
                                            valor={item.recibo.toString()}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        )
                    })
                }
            </Grid>

            {
                maxSteps > 1 &&
                <MobileStepper
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                    color='success'
                    nextButton={
                        <Button color='success'
                            size="small"
                            onClick={handleNext}
                            disabled={activeStep === maxSteps - 1}
                        >
                            <KeyboardArrowRight />
                        </Button>
                    }
                    backButton={
                        <Button
                            color='success'
                            size="small"
                            onClick={handleBack}
                            disabled={activeStep === 0}
                        >
                            <KeyboardArrowLeft />
                        </Button>
                    }
                    sx={{
                        px: 0,
                        bgcolor: "transparent"
                    }}
                />
            }

            {
                temRecibo &&
                <Box display="flex" justifyContent="center" alignItems="center" gap={1} mt={2}>
                    <BtnImprimirRecibo {...{ numRecibo }} />
                    <BtnCompartilhar 
                        mensagem={'mensagem'}
                        meio={['email']}
                        recibo={ numRecibo }
                    />
                </Box>
            }
        </Container>
    )
}

interface MostrarReciboProps {
    tipoModal: "Receber" | "Pagar"
    temRecibo?: boolean
}


function LabelRecibo({
    titulo,
    valor
}: { titulo: string, valor: string }) {
    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="body1">
                    {titulo}
                </Typography>
            </Box>
            <Box display="flex" gap={1}>
                <Typography variant="h5" fontWeight="bold">
                    {valor}
                </Typography>
            </Box>
        </Box>
    )
}